import React from 'react';

import {colors} from 'styles/shared';

function Icon() {
  return (
    <svg width="26" height="26" fill="none" viewBox="0 0 26 26">
      <path
        fill={colors.blue_main}
        fillRule="evenodd"
        d="M3.224 21.632C1.612 20.904.52 19.24.52 17.42V3.12A3.13 3.13 0 013.64 0h11.44a3.13 3.13 0 013.12 3.12V5.2c0 .572-.468 1.04-1.04 1.04-.572 0-1.04-.468-1.04-1.04V3.12c0-.572-.468-1.04-1.04-1.04H6.344l7.02 3.224c.364.156.624.52.624.936v12.48h1.04c.572 0 1.04-.468 1.04-1.04V15.6c0-.572.468-1.04 1.04-1.04.572 0 1.04.468 1.04 1.04v2.08a3.13 3.13 0 01-3.12 3.12h-1.04v4.16c0 .572-.468 1.04-1.04 1.04-.123 0-.214-.033-.324-.072a4.414 4.414 0 00-.092-.032l-9.308-4.264zm-.52-18.928a.98.98 0 00-.104.416v14.3c0 1.04.624 1.924 1.508 2.34l7.852 3.588V6.916L2.704 2.704zm17.888 3.952c.364-.416 1.04-.468 1.456-.104l3.12 3.12c.416.416.416 1.04 0 1.456l-3.12 3.12c0 .032-.02.044-.047.061-.017.01-.037.023-.057.043-.416.364-1.092.312-1.456-.104-.364-.416-.312-1.092.104-1.456l1.352-1.352H17.16c-.572 0-1.04-.468-1.04-1.04 0-.572.468-1.04 1.04-1.04h4.784l-1.352-1.352c-.312-.364-.312-.988 0-1.352z"
        clipRule="evenodd"></path>
    </svg>
  );
}

export default Icon;
